module.exports = __webpack_public_path__ + "static/media/dressing3.0ca52771.jpg";